import { CancellationTicket } from './cancellation-ticket';
import { InvoiceTicket } from './invoice-ticket';
import { ReservationTicket } from './reservation-ticket';
import { InvoiceOrderStatusTranslationsService } from 'src/app/shared/translations';

/**
 * Blueprint for the customer status object.
 */
export class InvoiceTicketByYear {
  public invoiceTickets: Array<InvoiceTicket | CancellationTicket | ReservationTicket> = [];
  public opened: boolean;
  public year: string;

  constructor(data?: any, key?: string, translations?: InvoiceOrderStatusTranslationsService) {
    data.forEach(invoice => {
      if (invoice.type === 'Cancellation') {
        this.invoiceTickets.push(new CancellationTicket(invoice, translations));
      } else if (invoice.type === 'Invoice') {
        this.invoiceTickets.push(new InvoiceTicket(invoice, translations));
      } else {
        this.invoiceTickets.push(new ReservationTicket(invoice, translations));
      }
    });
    this.year = key;
    this.opened = true;
   }
}
